import {Tooltip} from '@components/common/tooltip/tooltip'
import {cn} from '@containers/html-utils'
import * as React from 'react'

interface Props {
  onClick: React.MouseEventHandler<HTMLDivElement>
  icon: React.ReactElement
  hovered: React.ReactElement
  active: React.ReactElement
  className?: string
  tooltip: string
}

export const Action = ({
  onClick,
  icon,
  hovered,
  active,
  className,
  tooltip
}: Props) => {
  return (
    <Tooltip content={tooltip} placement="top-start" offset={[0, 10]}>
      <div className={cn('group h-24 w-24', className)} onClick={onClick}>
        <div className="block group-hover:hidden group-active:hidden">
          {icon}
        </div>
        <div className="hidden group-hover:block group-active:hidden">
          {hovered}
        </div>
        <div className="hidden group-active:block">{active}</div>
      </div>
    </Tooltip>
  )
}
